import { render, staticRenderFns } from "./videoLearning.vue?vue&type=template&id=4f7e4e33&scoped=true&"
import script from "./videoLearning.vue?vue&type=script&lang=js&"
export * from "./videoLearning.vue?vue&type=script&lang=js&"
import style0 from "./videoLearning.vue?vue&type=style&index=0&id=4f7e4e33&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7e4e33",
  null
  
)

export default component.exports